import { Component, OnDestroy, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/Services/user.service';
import { MessagingService } from 'src/app/Services/messaging.service';
import { TourActiveService } from 'src/app/Services/tour-active.service';
import { ChangeSideBarTooltipLanguage } from 'src/app/Services/change-sidebar-tooltip.service';

import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ExchangeService } from '../../Services/exchange.service';
import { takeUntil } from 'rxjs/operators';

declare var $: any;
import { zendeskLogOut } from 'src/app/Services/zendesk.service';
import { ToastrService } from 'ngx-toastr';
import { GlobalConstants } from '../global-constans';
import { CustomUrlSerializer } from '../../shared/models/UrlSerializer/custom-url-serializer';
import { ObsicashStoreService } from '../../Services/obsicash/obsicash-store.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  userData: any = {};
  activeMenu: any = 1;
  isSmallSidebar = false;
  unsubscribe$: Subject<void> = new Subject<void>();
  notification: any = {};
  version: any = '';
  language: any;
  activeModuleObsicash = '';
  env: any = environment.env;
  public imgUrl: any = environment.imgUrl;
  public showCookies: boolean;

  constructor(
    private cookieService: CookieService,
    private messagingService: MessagingService,
    public obsicashStore: ObsicashStoreService,
    public userService: UserService,
    private toast: ToastrService,
    private route: Router,
    private translate: TranslateService,
    private tourActiveService: TourActiveService,
    private changeSideBarTooltipLanguage: ChangeSideBarTooltipLanguage,
    public exchangeService: ExchangeService
  ) {
    this.userData = userService.getLoggedData();
    this.obsicashStore.enabledModules = this.userData.modules;
    this.version = environment.version;
    this.route.events.pipe(takeUntil(this.unsubscribe$)).subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (!environment.production) {
          console.log('CustomUrlSerializer.decript(val.url)', CustomUrlSerializer.decript(val.url));
        }
        if (
          CustomUrlSerializer.decript(val.url).indexOf('dashboard') !== -1 ||
          CustomUrlSerializer.decript(val.url).indexOf('tutorial') !== -1
        ) {
          this.activeMenu = 1;
        } else if (CustomUrlSerializer.decript(val.url).indexOf('buy-sell') !== -1 && CustomUrlSerializer.decript(val.url).indexOf('obsicash') == -1) {
          this.activeMenu = 6;
        } else if (CustomUrlSerializer.decript(val.url).indexOf('private-trade') !== -1 && CustomUrlSerializer.decript(val.url).indexOf('obsicash') == -1) {
          this.activeMenu = 7;
        } else if (CustomUrlSerializer.decript(val.url).indexOf('simple-exchange') !== -1 && CustomUrlSerializer.decript(val.url).indexOf('obsicash') == -1) {
          this.activeMenu = 5;
        } else if (CustomUrlSerializer.decript(val.url).indexOf('exchange') !== -1 && CustomUrlSerializer.decript(val.url).indexOf('obsicash') == -1) {
          this.activeMenu = 5;
        } else if ((CustomUrlSerializer.decript(val.url).indexOf('wallet') !== -1 || CustomUrlSerializer.decript(val.url).indexOf('whitelist') !== -1) && CustomUrlSerializer.decript(val.url).indexOf('obsicash') == -1) {
          this.activeMenu = 8;
        } else if ((CustomUrlSerializer.decript(val.url).indexOf('quick-transfer') !== -1 || CustomUrlSerializer.decript(val.url).indexOf('transfer-history') !== -1) && CustomUrlSerializer.decript(val.url).indexOf('obsicash') == -1) {
          this.activeMenu = 11;
        } else if (CustomUrlSerializer.decript(val.url).indexOf('orders') !== -1 && CustomUrlSerializer.decript(val.url).indexOf('obsicash') == -1) {
          this.activeMenu = 10;

        } else if (CustomUrlSerializer.decript(val.url).indexOf('prices') !== -1 && CustomUrlSerializer.decript(val.url).indexOf('obsicash') == -1) {
          this.activeMenu = 2;
        } else if (CustomUrlSerializer.decript(val.url).indexOf('payment') !== -1) {
          this.activeMenu = 4; // buy cripto with
        } else if (CustomUrlSerializer.decript(val.url).indexOf('obsicash') !== -1 && CustomUrlSerializer.decript(val.url).indexOf('addCash-CashOut') == -1) {
          this.activeMenu = 4;
        } else if (CustomUrlSerializer.decript(val.url).indexOf('obsicash/addCash-CashOut') !== -1) {
          this.activeMenu = 9;

        } else if (CustomUrlSerializer.decript(val.url).indexOf('promotions') !== -1) {
          this.activeMenu = 12;

        } else {
          this.activeMenu = -1;
        }
      }
    });
    this.showActiveModuleObsicash();
  }

  showActiveModuleObsicash() {
    let moduleActive = this.userData.modules.filter(item => item.module === 'OBSICASH CASH IN');
    if (moduleActive.length > 0) {
      this.activeModuleObsicash = 'obsicash/addCash-CashOut/cash-in';
      return false;
    }
    moduleActive = this.userData.modules.filter(item => item.module === 'OBSICASH CASH OUT');
    if (moduleActive.length > 0) {
      this.activeModuleObsicash = 'obsicash/addCash-CashOut/cash-out';
      return false;
    }
    moduleActive = this.userData.modules.filter(item => item.module === 'OBSICASH HISTORY');
    if (moduleActive.length > 0) {
      this.activeModuleObsicash = 'obsicash/addCash-CashOut/history-new';
      return false;
    }
    moduleActive = this.userData.modules.filter(item => item.module === 'OBSICASH ACCOUNTS');
    if (moduleActive.length > 0) {
      this.activeModuleObsicash = 'obsicash/addCash-CashOut/associate-account-new';
      return false;
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit() {
    GlobalConstants.languageChangeFunctionCallInHeader = true;
    this.setTourTitle();
    this.userService.verificationEvent
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isOpen) => {
        this.userData = this.userService.getLoggedData();
      });
    this.userService.changeData
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isOpen) => {
        this.userData = this.userService.getLoggedData();
      });
    this.language =
      this.cookieService.get('OBSIDIAM-LOCALE') ||
      navigator.language.slice(0, 2);
    this.translate.setDefaultLang(this.language.toLowerCase());
    this.userService.unreadNotificationEvent
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((a: any) => {
        this.notification = {};
        (a || []).map((m) => {
          if (
            [
              'paymentApproved',
              'paymentSent',
              'orderTaken',
              'orderCancelled',
              'orderApproved',
              'increasePaymentTimeRequested',
              'increasePaymentTimeApproved',
              'increasePaymentTimeRejected',
              'message',
              'disputeResolved',
            ].indexOf(m.notificationType) != -1
          ) {
            this.notification.order = true;
          }
          if (
            ['userAdded', 'quickTransferReceived', 'quickTransferSent'].indexOf(
              m.notificationType
            ) != -1
          ) {
            this.notification.pay = true;
          }
          if (['deposit', 'withdraw'].indexOf(m.notificationType) != -1) {
            this.notification.wallet = true;
          }
          return m;
        });
      });

    // $('.sidebar .logout').addClass('disabled');
    $('#sidebarToggle').click(function () {
      $(this).toggleClass('toggleActive');
      $('.sidebar').toggleClass('sidehover');
      $('.homemain').toggleClass('homehover');
      $('.home_fixed').toggleClass('home_fixedhover');
      $(this).hasClass('toggleActive')
        ? $('.logohome a img').attr(
          'src',
          './assets/images/obsidiam_logo_blanco.png'
        )
        : $('.logohome a img').attr(
          'src',
          'https://cdn-dev.obsidiam.com/img/obsidiam_welcome.png'
        );
      $(this).hasClass('toggleActive')
        ? $('.logohome a img').attr('style', '')
        : $('.logohome a img').attr('style', 'height : auto;');
      $('.stick_fixed').toggleClass('home_fixedhover');
    });
    this.setTooltipText();
    this.changeSideBarTooltipLanguage.changeTooltipLang.pipe(takeUntil(this.unsubscribe$)).subscribe((tabName: any) => {
      this.setTooltipText();
    });

    $('#DashBoardTooltip, #BuySellTooltip, #ExchangeTooltip1, #BuyWithTooltip, #PromotionTooltip, #WalletTooltip, #ObsidiamPayTooltip, #OrdersTooltip, ' +
      '#PricesTooltip, #LogOutTooltip, #ExchangeTooltip2, #ObsidiamProTooltip')
      .tooltip({ trigger: 'hover' });

    this.tourActiveService.openTabEvent.pipe(takeUntil(this.unsubscribe$)).subscribe((tabName: any) => {
      this.isSmallSidebar = false;
      if (tabName === 'buy-sell') {
        $('#BuySellCollapse').collapse('show');
      } else if (tabName === 'exchange') {
        $('#ExchangeCollapse').collapse('show');
      } else {
        $('.collapse').collapse('hide');
      }
    });
    setTimeout(() => {
      this.resize_to_fit();
    }, 500);
  }

  resize_to_fit() {
    let maxW = 220, maxH = 30, maxSize = 12;
    let c = document.getElementsByClassName('fitText') as HTMLCollectionOf<HTMLElement>;
    let d = document.createElement('span');
    d.style.fontSize = maxSize + 'px';

    for (let i = 0; i < c.length; i++) {
      d.innerHTML = c[i].innerHTML;
      document.body.appendChild(d);
      const w = d.offsetWidth;
      const h = d.offsetHeight;
      document.body.removeChild(d);
      const x = w > maxW ? maxW / w : 1;
      const y = h > maxH ? maxH / h : 1;
      const r = Math.min(x, y) * maxSize;
      c[i].style.fontSize = r + 'px';
    }
  }

  checkForBothDisable() {
    let visible = true;
    let p2pMarket = false;
    let p2pPrivate = false;

    if (this.userData && this.userData.modules) {
      this.userData.modules.forEach((modules) => {
        if ('P2P PRIVATE' === modules.module) {
          p2pPrivate = true;
        }
        if ('P2P MARKET' === modules.module) {
          p2pMarket = true;
        }
      });
    }
    if (!p2pMarket && !p2pPrivate) {
      visible = false;
    }
    return visible;
  }

  setTooltipText() {
    this.translate.get('sidebar.verifyUser').pipe(takeUntil(this.unsubscribe$)).subscribe((type: any) => {
      $('#DashBoardTooltip').tooltip({
        title: type
      });

    });
  }

  logOut() {
    const isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
    const data = { source: isMobile ? 'Mobile' : 'Website' };
    this.userService.logout(data, this.userData.token).pipe(takeUntil(this.unsubscribe$)).toPromise().then((n: any) => {
      if (n.status === 200) {
        zendeskLogOut();
        this.cookieService.deleteAll('/');
        this.userService.deleteUserData();
        this.userService.deleteToken();
        this.userService.isLoggedIn = false;
        this.userService.setUserData({});
        this.userService.setToken('');
        this.messagingService.changeVerificationStatus();

        sessionStorage.setItem('cookies', this.cookieService.get('cookies') ? JSON.parse(this.cookieService.get('cookies')) : '');
        sessionStorage.setItem('takeFeeOff', this.cookieService.get('takeFeeOff') ? JSON.parse(this.cookieService.get('takeFeeOff')) : '');
        sessionStorage.setItem('rememberLate', this.cookieService.get('rememberLate') ? JSON.parse(this.cookieService.get('rememberLate')) : '');
        this.cookieService.delete('cookies');
        this.cookieService.delete('takeFeeOff');
        this.cookieService.delete('rememberLate');
        localStorage.clear();

        if (!environment.production) {
          console.log('SIDEBAR 149: HIT LOG OUT EVENT');
          // console.log('this.cookieService.get(environment.authName);', this.cookieService.get(environment.authName));
        }
        this.userService.logOutEventHit();
        this.route.navigate(['/login']);
      }
    });
  }

  checkFirstClick(bottomClicked, navigateTo) {
    if (navigateTo == 'obsidiamExchange') {
      this.route.navigate(['/simple-exchange/BTC_USDT']);
    } else if (navigateTo == 'payment') {
      if (this.userData && this.userData.verificationStatusString && this.userData.verificationStatusString === 'SUCCESS') {
        this.route.navigate(['/payment']);

      } else {
        this.translate.get('sidebar.verifyUser').pipe(takeUntil(this.unsubscribe$)).subscribe((type: any) => {
          this.toast.info(type, '', {
            timeOut: 15000
          });
        });
      }
    }
  }

  collapseAll(isCollapseTab) {
    $('#BuySellTooltip, #ExchangeTooltip, #ObsidiamProTooltip').tooltip('hide');
    $('.collapse').collapse('hide');
    if (this.isSmallSidebar && isCollapseTab) {
      this.isSmallSidebar = !this.isSmallSidebar;
      $('#sidebarToggle').click();
      $('#BuySellTooltip, #ExchangeTooltip, #ObsidiamProTooltip').tooltip('hide');
    }

  }

  // collapseAllBluebank(isCollapseTab) {
  //   $("#BuySellTooltip, #ExchangeTooltip, #ObsidiamProTooltip").tooltip("hide");
  //   $(".collapse").collapse("hide");
  //   if (this.isSmallSidebar && isCollapseTab) {
  //     this.isSmallSidebar = !this.isSmallSidebar;
  //     $("#sidebarToggle").click();
  //     $("#BlueBankTooltip, #ExchangeTooltip, #ObsidiamProTooltip").tooltip(
  //       "hide"
  //     );
  //   }
  // }

  smallSidebar() {
    this.isSmallSidebar = !this.isSmallSidebar;
    $('.collapse').collapse('hide');
  }

  setTourTitle() {
    if (GlobalConstants.languageChangeFunctionCallInHeader) {
      GlobalConstants.languageChangeFunctionCallInHeader = false;

      this.translate.get('sidebar.dashboard').pipe(takeUntil(this.unsubscribe$)).subscribe((type: any) => {
        $('#DashBoardTooltip').attr('data-original-title', type);
      });
      this.translate.get('sidebar.prices').pipe(takeUntil(this.unsubscribe$)).subscribe((type: any) => {
        $('#PricesTooltip').attr('data-original-title', type);
      });
      this.translate.get('sidebar.buy_sell').pipe(takeUntil(this.unsubscribe$)).subscribe((type: any) => {
        $('#BuySellTooltip').attr('data-original-title', type);
      });
      this.translate.get('sidebar.private_sales').pipe(takeUntil(this.unsubscribe$)).subscribe((type: any) => {
        $('#PrivateMarketToolTip').attr('data-original-title', type);
      });

      this.translate.get('sidebar.payments').pipe(takeUntil(this.unsubscribe$)).subscribe((type: any) => {
        $('#BuyWithTooltip').attr('data-original-title', type);
      });
      this.translate.get('sidebar.exchange').pipe(takeUntil(this.unsubscribe$)).subscribe((type: any) => {
        $('#ExchangeTooltip1').attr('data-original-title', type);
      });
      this.translate.get('sidebar.wallet').pipe(takeUntil(this.unsubscribe$)).subscribe((type: any) => {
        $('#WalletTooltip').attr('data-original-title', type);
      });
      this.translate.get('sidebar.orders_offers').pipe(takeUntil(this.unsubscribe$)).subscribe((type: any) => {
        $('#OrdersTooltip').attr('data-original-title', type);
      });
      this.translate.get('sidebar.OBSIPAY').pipe(takeUntil(this.unsubscribe$)).subscribe((type: any) => {
        $('#ObsidiamPayTooltip').attr('data-original-title', type);
      });
      this.translate.get('sidebar.exchange').pipe(takeUntil(this.unsubscribe$)).subscribe((type: any) => {
        $('#ObsidiamProTooltip').attr('data-original-title', type);
      });
      this.translate.get('sidebar.log_out').pipe(takeUntil(this.unsubscribe$)).subscribe((type: any) => {
        $('#LogOutTooltip').attr('data-original-title', type);
      });
      this.translate.get('Obsicash').pipe(takeUntil(this.unsubscribe$)).subscribe((type: any) => {
        $('#obsicashTooltip').attr('data-original-title', type);
      });

    }
  }
  goToLandingPage() {
    window.open(environment.landingPageUrl, '_self');
  }
}
